'use strict'

import ky from 'ky-universal'
import env from './../env'

export default function (file) {
   // To prevent memory leaks
   window.URL.revokeObjectURL(file)

   return ky
      .post(`${env.apiUrl}/asset-url`, {
         json: { hashedFileName: file.nameWithHash, fileType: file.type },
         credentials: 'include'
      })
      .json()
      .then(resp => {
         return ky
            .put(resp.uploadUrl, {
               headers: {
                  'Content-Type': file.type,
                  'x-amz-acl': 'public-read',
               },
               body: file,
            })
            .then(response => {
               if (!response.ok) {
                  throw new Error(`${response.status}: ${response.statusText}`)
               }
               return response
            })
      })
}
